import { ISaleCompanyJson } from '../../Components/Sale/SaleView';
import XhrRequestHandler, { getQueryParamsExpression, QueryParam } from '../../lib/XhrRequestHandler';
import { Company, CompanyJson, IconpanyList, IdetailCompany, Ipais, IsaveContactcompany, IsaveEmpresa, Isoapruc, IupdateContactcompany } from './Company';
import { Currency } from './Currency';
import { Rubro } from './Rubro';

export class CompanySystem {
  private readonly base = '/empresas';
  private readonly basepais = '/paises';
  private readonly baseEmpresaVentasDriver = '/empresa-ventas-driver';

  constructor(private requestHandler: XhrRequestHandler) {}

  async getEmpresaById(id: string) {
    let ret = await this.requestHandler.get<CompanyJson>(`${this.base}/${id}`);
    return Company.fromJson(ret);
  }

  async getList(params?: QueryParam[]) {
    const query = getQueryParamsExpression(params);
    let ret = await this.requestHandler.get<CompanyJson[]>(`${this.base}${query}`);
    return ret.map((emp) => Company.fromJson(emp));
  }

  async getListComapniesActives(period) {
    let ret = await this.requestHandler.get<any>(`${this.base}/list_companies/${period}`);
    return ret.data.map((emp) => Company.fromJson(emp));
  }

  async getEmpresasByCountry(coutryId)  {
    return await this.requestHandler.get<any>(
      `${this.base}/country/${coutryId}`
    );
  }

  async mainCompanyCurrency(): Promise<Currency> {
    const data = await this.requestHandler.get<ICurrency>(`${this.base}/getMonedaEmpresaPrincipal`);

    return Currency.identified(
        data.moneda_id,
        data.moneda_denominacion,
        data.moneda_simbolo,
        +data.moneda_cotiz_us_dollar
    );
  }
  
  getBaseUrlForDatagridEmpresas(){
    return this.requestHandler.requestUrl(`${this.base}/datagridEmpresas`);
  }

  async getPaises(uuid:string,message:string,optionkey:number=0){
    const header = {uuid,message};
    const data = await  this.requestHandler.getheader<Ipais[]>(`${this.basepais}/get-list`,header);
    const result = data.map((item)=>({key:optionkey===1?item.pais_id:item.pais_nombre,text:item.pais_nombre}) );
    return result;
  }

  async getListTipo(uuid:string,message:string){
    const header = {uuid,message};
    const data = await  this.requestHandler.getheader<any[]>(`${this.base}/list-tipo`,header);
    const result = data.map((item)=>({key:item.emp_tipo,text:item.emp_tipo}) );
    return result;
  }

  async getListRubros(uuid:string,message:string){
    const header = {uuid,message};
    return this.requestHandler.getheader<Rubro[]>(`${this.base}/list-rubros`,header);
  }

  async getInfoSoap(uuid:string,message:string,id:string){
    const header = {uuid,message};
    const data = await this.requestHandler.getheader<Isoapruc | undefined>(`${this.base}/nif/${id}`,header);
    return data
  }

  async createCompany(data,uuid:string,message:string) {
    const header = {uuid,message};
    const result =  await this.requestHandler.postss<IsaveEmpresa>(`${this.base}/save_empresa`, data,header);
    return result;
  }

  async detailCompany(uuid:string, message:string, id:string|undefined){
    const header = {uuid,message};
    const data = await this.requestHandler.getheader<IdetailCompany>(`${this.base}/empresadetail/${id}`,header);
    return data;
  }

  async updateCompany(data,uuid:string, message:string){
    const header ={uuid,message};
    const result = await this.requestHandler.postss<IsaveEmpresa >(`${this.base}/update_empresa`, data,header);
    return result;
  }

  async listCompanyContact(uuid:string, message:string,empId:string){
    const header = {uuid,message};
    const result = await this.requestHandler.getheader<IconpanyList>(`${this.base}/list_emp_contact/${empId}`,header);
    return result;
  }

  async saveContactcompany(data:IsaveContactcompany,uuid:string , message:string){
    const header = {uuid,message};
    const result = await this.requestHandler.postss<{success:boolean,message:string}>(`${this.base}/save_emp_contact`, data,header);
    return result;
  }

  async updateContactcompany(data:IupdateContactcompany,uuid:string , message:string){
    const header = {uuid,message};
    const result = await this.requestHandler.postss<{success:boolean,message:string}>(`${this.base}/update_emp_contact`, data,header);
    return result;
  }

  async deleContactEmp(uuid:string ,message: string, id:string){
    const header = {uuid, message};
    const result = await this.requestHandler.getheader<{success:boolean,message:string}>(`${this.base}/delete_emp_contact/${id}`,header);
    return result;
  }

  async validateEmaiil(uuid:string ,message: string, email:string, empctempid:string){
    const header = {uuid,message};
    const result = await this.requestHandler.getheader<{success:boolean,data:string}>(`${this.base}/email_emp_contact/${email}/${empctempid}`,header);
    return result;
  }

  getListEmpresaVentasDriverForDatagrid() {
    return this.requestHandler.requestUrl(
      `${this.baseEmpresaVentasDriver}/datagridEmpresaVentasDriver`,
    );
  }

  async updateDistributionSaleCompany(data:ISaleCompanyJson){
    const result = await this.requestHandler.post<{success:boolean,message:string}>(`${this.baseEmpresaVentasDriver}`, data);
    return result;
  }

  async registerEmpresaVentasDriver(listCompaniesSaleDriver: ISaleCompanyJson[]) {
    const result = await this.requestHandler.post<{success:boolean,message:string}>(`${this.baseEmpresaVentasDriver}/import-empresaVentasDriver`, listCompaniesSaleDriver);
    return result;
  }
}

interface ICurrency {
  moneda_denominacion: string;
  moneda_id: string;
  moneda_simbolo: string;
  moneda_cotiz_us_dollar: string;
}

export default CompanySystem;
